import React from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";

const ContactSection = () => {
    return (
        <section className="contact-section py-5 ">
            <Container>
                <Row className="align-items-center g-4 shadow-lg p-3 rounded-4">

                    {/* LEFT FORM */}
                    <Col lg={7}>
                        <div className="mb-3 contact-head fw-semibold">
                            ✦ Contact Us ✦
                        </div>

                        <h2 className="fw-bold mb-4">
                            TechIn Contact Information Here
                        </h2>

                        <Card className="border-0 shadow-sm contact-form-card">
                            <Card.Body>
                                <Row className="g-3">
                                    <Col md={6}>
                                        <Form.Control
                                            type="text"
                                            placeholder="First Name"
                                        />
                                    </Col>

                                    <Col md={6}>
                                        <Form.Control
                                            type="text"
                                            placeholder="Last Name"
                                        />
                                    </Col>

                                    <Col md={6}>
                                        <Form.Control
                                            type="email"
                                            placeholder="Email Address"
                                        />
                                    </Col>

                                    <Col md={6}>
                                        <Form.Select>
                                            <option>Select Service</option>
                                            <option>Web Design</option>
                                            <option>UI/UX Design</option>
                                            <option>Development</option>
                                        </Form.Select>
                                    </Col>

                                    <Col md={12}>
                                        <Form.Control
                                            as="textarea"
                                            rows={4}
                                            placeholder="Message Here..."
                                        />
                                    </Col>

                                    <Col md={12}>
                                        <Button className="btn-grad border-0 fw-bold btn btn btn-primary px-4 py-2">
                                            Send Message
                                        </Button>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* RIGHT INFO PANEL */}
                    <Col lg={5}>
                        <div className="contact-info-panel text-white">
                            <h3 className="fw-bold mb-4">Let's Get In Touch!</h3>

                            <div className="info-item">
                                <i className="bi bi-alarm"></i>
                                <div>
                                    <h6>Office Time</h6>
                                    <p>Mon–Fri: 10:00AM – 09:00PM</p>
                                </div>
                            </div>

                            <div className="info-item">
                                <i className="bi bi-telephone"></i>
                                <div>
                                    <h6>Call Us Any Time</h6>
                                    <p>(+009) 1888 000 2222</p>
                                </div>
                            </div>

                            <div className="info-item">
                                <i className="bi bi-envelope"></i>
                                <div>
                                    <h6>Email Address</h6>
                                    <p>info@techin.com</p>
                                </div>
                            </div>

                            <div className="info-item">
                                <i className="bi bi-geo-alt"></i>
                                <div>
                                    <h6>Office Address</h6>
                                    <p>12th Street, New York, USA</p>
                                </div>
                            </div>
                        </div>
                    </Col>

                </Row>
            </Container>
            <div className="container pt-3"> <div className="ratio ratio-16x9"> <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3801.6317823087243!2d75.92209907391307!3d17.667590394675077!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc5da64017f2cad%3A0x9696761cef43dc11!2sVertex%20Technosys!5e0!3m2!1sen!2sin!4v1767353281605!5m2!1sen!2sin" style={{ border: 0, height: "75vh" }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Vertex Technosys Location" ></iframe> </div> </div>
        </section>
    );
};

export default ContactSection;
